import { Logo } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';

const Header = (props) => {
  const { customer, step, onMenuClick, settings } = props;
  return (
    <div className="c7-checkout__header">
      <Logo />

      {renderMenu(customer, step, onMenuClick, settings)}
    </div>
  );
};

const renderMenu = (customer, step, onMenuClick, settings) => {
  const customerClick = (e) => {
    e.preventDefault();
    onMenuClick('customer');
  };
  const billingClick = (e) => {
    e.preventDefault();
    onMenuClick('billing');
  };
  const accountClick = (e) => {
    e.preventDefault();
    onMenuClick('account');
  };
  const paymentClick = (e) => {
    e.preventDefault();
    onMenuClick('payment');
  };
  let clubSelection = 'Club Selection';
  if (isPreSale()) {
    clubSelection = 'Pre-Sale Selection';
  }
  switch (step) {
    case 'customer': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div className="active">Customer</div>
          <div>Billing</div>
          {renderAccount(customer, false)}
          <div>Payment</div>
        </div>
      );
    }
    case 'billing': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer</a>
          </div>
          <div className="active">Billing</div>
          {renderAccount(customer, false)}
          <div>Payment</div>
        </div>
      );
    }
    case 'account': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer</a>
          </div>
          <div>
            <a onClick={billingClick}>Billing</a>
          </div>
          {renderAccount(customer, true)}
          <div>Payment</div>
        </div>
      );
    }
    case 'payment': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer</a>
          </div>
          <div>
            <a onClick={billingClick}>Billing</a>
          </div>
          {renderAccount(customer, false)}
          <div className="active">Payment</div>
        </div>
      );
    }
    case 'complete': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href={`${getClubList(settings)}`}>{clubSelection}</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer</a>
          </div>
          <div>
            <a onClick={billingClick}>Billing</a>
          </div>
          {renderAccount(customer, true, accountClick)}
          <div>
            <a onClick={paymentClick}>Payment</a>
          </div>
        </div>
      );
    }
    default:
      throw new Error('Invalid Step');
  }
};

const renderAccount = (customer, isActive, accountClick) => {
  if (!customer) {
    if (!isActive && !accountClick) {
      return <div>Account</div>;
    }
    if (!isActive) {
      return (
        <div>
          <a onClick={accountClick}>Account</a>
        </div>
      );
    }
    return <div className="active">Account</div>;
  }
  return null;
};

export default Header;
